import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import Statistics from "./sections/Statistics";
import Leadership from "./sections/Leadership";
import Founding from "./sections/Founding";
import Ribbon from "./sections/Ribbon";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <AboutHero />
      <Statistics />
      <Leadership />
      <Founding />
      <Ribbon />
      <Footer />
    </div>;
}